import React, { Component, isValidElement } from 'react';
import { APP_CONST } from '../../constants';
import { Utils } from '../../services';

class GeckoBtn extends Component {

    state = {
        disabled: false
    };

    renderId() {
        if (!this.props.id) return undefined;
        return `gecko-btn-${this.props.id}`;
    }

    preparePreset(key){
        if (this.props.preset && APP_CONST.BTN_PRESETS[this.props.preset] && APP_CONST.BTN_PRESETS[this.props.preset][key]){
            return APP_CONST.BTN_PRESETS[this.props.preset][key];
        }
        return null;
    }

    // Prepare class name
    prepareClass() {
        let type = this.props.type || this.preparePreset('type') || APP_CONST.BTN_TYPE_OUTLINE;
        return APP_CONST.BTN_CLASSES[type];        
    }

    prepareIcon() {
        return this.props.icon || this.preparePreset('icon');
    }

    // Render button name
    renderName() {
        return this.props.name || this.preparePreset('name') || null;
    }

    renderAriaLabel() {
        return this.props.ariaLabel || this.preparePreset('ariaLabel') || null;
    }

    getSizeClasses() {
        const size = this.props.size || 'default';
        const isIconOnly = !this.renderName() && this.prepareIcon();
        
        const sizeMap = {
            'sm': {
                base: 'h-8 gap-1.5 px-3',
                withIcon: 'has-[>svg]:px-2.5',
                iconOnly: 'size-7'
            },
            'default': {
                base: 'h-10 gap-2 px-4',
                withIcon: 'has-[>svg]:px-3',
                iconOnly: 'size-9'
            },
            'lg': {
                base: 'h-12 gap-2 px-6',
                withIcon: 'has-[>svg]:px-4',
                iconOnly: 'size-11'
            }
        };

        const sizeConfig = sizeMap[size] || sizeMap['default'];
        
        if (isIconOnly) {
            return sizeConfig.iconOnly;
        }
        
        return `${sizeConfig.base} ${sizeConfig.withIcon}`;
    }

    // Render button class
    renderClass() {
        const baseClasses = 'inline-flex items-center justify-center whitespace-nowrap rounded-sm text-sm font-medium transition-all cursor-pointer disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*="size-"])]:size-3.5 shrink-0 [&_svg]:shrink-0 outline-none aria-invalid:ring-destructive/20 aria-invalid:border-destructive';
        
        return Utils.classNames({
            [Utils.prepareNameClass('gecko-btn', this.renderName())]: this.renderName(),
            'gecko-btn': true,
            [baseClasses]: true,
            [this.prepareClass()]: true,
            [this.getSizeClasses()]: true,
            [this.props.className]: this.props.className
        });
    }

    renderIcon() {
        const iconProp = this.prepareIcon();
        if (!iconProp) return null;

        // Support passing a React element or a component (including forwardRef objects)
        const iconElement = isValidElement(iconProp)
            ? iconProp
            : (() => {
                const IconComponent = iconProp;
                return <IconComponent />;
            })();
        if (!iconElement) return null;

        if (this.renderName()) {
            return <span>{iconElement}</span>;
        }
        return iconElement;
    }

    iconPosition() {
        return this.props.iconPosition || this.preparePreset('iconPosition') || 'left';
    }

    renderSrOnly() {
        if (!this.renderName() && this.renderAriaLabel()) {
            return (<span className="sr-only">{this.renderAriaLabel()}</span>);
        }
        return null;
    }

    isDisabled() {
        return this.state.disabled || (this.props.disabledWhen ? this.props.disabledWhen() : false);
    }

    isHidden()
    {
        if (this.props.hideWhen && this.props.hideWhen()) {
            return true;
        }

        return false;
    }

    handler() {
        let handler = this.props.handler();

        // If promise is returned disable button
        if (handler && handler instanceof Promise) {
            // Disable button
            this.setState({disabled: true});
            // Undisable button after promise has resolved or rejected
            return handler.then(() => {
                return this.setState({disabled: false});
            }).catch(() => {
                return this.setState({disabled: false});
            });
        }
    }

    render() {
        if (this.isHidden()) {
            return null;
        }


		const iconPosition = this.iconPosition();
        const iconElement = this.renderIcon();

		return (
            <button
                id={this.renderId()}
                type="button"
                role="button"
                aria-label={this.props.ariaLabel || this.renderName()}
                style={this.props.style}
                className={this.renderClass()}
                onClick={this.handler.bind(this)}
                disabled={this.isDisabled()}>

                    {iconPosition === 'left' && iconElement}

                    {this.renderName()}

                    {iconPosition === 'right' && iconElement}

                    {this.renderSrOnly()}

            </button>
        );
    }
}

GeckoBtn.defaultProps = {
    handler: () => {},
    style: {},
};

//GeckoBtn.propTypes = GeckoBtnModel;

export default GeckoBtn;